export type Entry<T> = {
  [K in keyof T]: [K, T[K]];
}[keyof T];

/** Calls Object.entries() but returns a strongly typed key and value. */
export function getEntries<T extends object>(obj: T) {
  return Object.entries(obj) as Entry<T>[];
}
export const entries = getEntries; // Alias for backwards compatibility

// Reading: https://stackoverflow.com/questions/73136600/generic-nullable-return-types-depends-on-params
export type Undefinable<T> = T | undefined;
export type UndefinableIf<C, T> = C extends undefined ? undefined : T;
export type Nullable<T> = T | null | undefined;
export type NullableIf<C, T> = C extends null | undefined ? null | undefined : T;

// https://stackoverflow.com/a/57334147/704532
// https://stackoverflow.com/a/78354994/704532
/** Marks every property as required (non-optional). However property values can still be undefined. */
export type Full<T> = { [K in keyof T]-?: [T[K]] } extends infer U
  ? U extends Record<keyof U, [unknown]>
    ? { [K in keyof U]: U[K][0] }
    : never
  : never;

/** Marks every property as required (non-optional). However property values can still be undefined. */
export function asFull<T>(x: T) {
  return x as Full<T>;
}

export function deleteFunctions<T>(obj: T): T {
  for (const key in obj) {
    if (typeof obj[key] === 'function') {
      delete obj[key];
    }
  }
  return obj;
}
